import dayjs from 'dayjs';

export const getFinishDate = (startDate: Date, finishTime: {
    hour: number,
    minute: number,
}) => {
    let finishDate;

    if (finishTime) {
        finishDate = dayjs(startDate);
        finishDate = finishDate.set('hour', finishTime?.hour).set('minute', finishTime?.minute);
    } else {
        finishDate = dayjs(startDate).add(1, 'day');
    }
    return finishDate;
};

